import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';

export type SeatItem = {
  block: string;
  seat: string;
  price: number;
};

@Component({
  selector: 'app-threed-seat-item',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './threed-seat-item.component.html',
  styleUrls: ['./threed-seat-item.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ThreedSeatItemComponent implements OnInit {
  @Input()
  seat!: SeatItem

  ngOnInit(): void {}
}
